export * from './getIsMobile';
export * from './getPlatform';
